<template>
    <div>
        <custom-table class="card-logs-table" ref="tables" :hover-flat="true" stripe :maxItems="50" :paginationWatch="[50, 100, 500]" :tableData="sortByDecreasing">
            <template v-slot:head class="header-table">
                <vs-th>{{$t('global.Date')}}</vs-th>
                <vs-th>{{$t('global.Event')}}</vs-th>
                <vs-th>{{$t('global.User')}}</vs-th>
                <vs-th>{{$t('global.message')}}</vs-th>
                <vs-th>{{$t('global.comment')}}</vs-th>
            </template>
            <template v-slot:content="{content}">
                <vs-td :class="getColorStatus(content.status)">
                    <div class="flex items-baseline">
                        <vs-icon icon-pack="feather" icon="icon-calendar" color="primary" class="mb-1 mr-1"/>
                        <p>{{content.log_date | date}}</p>
                    </div>
                    <div class="flex items-baseline">
                        <vs-icon icon-pack="feather" icon="icon-clock" color="primary" class="mr-1"/>
                        <p>{{content.log_date | time}}</p>
                    </div>
                </vs-td>
                <vs-td :class="getColorStatus(content.status)">
                    <div>
                        <p>{{content.operation}}</p>
                    </div>
                </vs-td>
                <vs-td :class="getColorStatus(content.status)">
                    <div>
                        <p>{{content.user_name}}</p>
                    </div>
                </vs-td>
                <vs-td class="card-logs-table__message" :class="getColorStatus(content.status)">
                    <div class="flex items-center">
                        <vx-tooltip :text="getMetaData(content.meta_data)" position="top" delay="0s">
                        <vs-icon v-if="Object.keys(content.meta_data).length" color="primary" icon-pack="feather" icon="icon-info"
                                 class="mr-2 cursor-pointer"></vs-icon>
                        </vx-tooltip>
                        <p>{{ content.message }}</p>
                    </div>
                </vs-td>
                <vs-td class="card-logs-table__comment" :class="getColorStatus(content.status)">
                    <div>
                        <p>{{content.comment}}</p>
                    </div>
                </vs-td>
            </template>
        </custom-table>
    </div>
</template>


<script>
import CustomTable from '@/components/custom-table/Table'
import {colorForCardStatuses} from '@/utils/mixins'

export default {
    name: 'CardLogs',
    mixins:[colorForCardStatuses],
    props:{
        popupData: Array,
    },
    components:{
        CustomTable
    },
    data(){
        return {}
    },
    computed:{
        sortByDecreasing(){
            return this.popupData.sort((a, b) => Date.parse(b.log_date) - Date.parse(a.log_date))
        },
    },
    methods:{
        getMetaData(data){
            let message = ''
            Object.keys(data).forEach(key => {
                let value = null;
                if (data[key]) {
                    if (typeof data[key] === 'object') {
                        value = data[key][Object.keys(data[key]).find(el => el !== 'id')]
                    } else {
                        value = data[key]
                    }
                }
                message += `${key.replace("card_", "")} = ${value}<br>`
            })
            return message
        },
        setWidthMainPopup(){
            let wrapperMainPopup = document.getElementById('mainPopup');
            let mainPopup = wrapperMainPopup.querySelector('.vs-popup');
            mainPopup.classList.toggle('w-auto')
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.setWidthMainPopup()
        })
    },
}
</script>

<style lang="scss">
    .con-vs-dropdown--menu {
        z-index: 100000;
    }

.card-logs-table{

    .vs-con-table .vs-con-tbody {
        background: white;
        border: none;
    }
    .vs-table--thead {
        tr {
            background: white!important;
        }
    }

    &__message, &__comment{
        max-width: 25vw;
        word-break: break-word;
    }

}
</style>
